import React, { useEffect, useState } from "react";
import "./Commitment.css";
import { motion } from "framer-motion";

import villageImg1 from "../assets/sst-img1.png";
import villageImg2 from "../assets/sst-img2.png";
import villageImg3 from "../assets/sst-img3.png";
import Footer from "./Footer";

const images = [villageImg1, villageImg2, villageImg3];

export default function SST() {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((previousImage) => {
        return (previousImage + 1) % images.length;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section id="commitment">
      <motion.div
        className="sst-container"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        {/* PAGE TITLE */}
        <div className="sst-title-wrapper">
          <h1 className="sst-title">
            Srinivasan Services Trust (SST)
          </h1>

          <div className="sst-underline"></div>
        </div>

        {/* IMPACT SECTION */}
        <div className="impact-container">
          <div className="impact-image">
            <motion.img
              key={currentImage}
              src={images[currentImage]}
              alt="Village"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
            />
          </div>

          <div className="impact-stats">
            <div className="stat-box">
              <h2>28</h2>
              <p>Years</p>
            </div>

            <div className="stat-box">
              <h2>0.3 Mn</h2>
              <p>Households</p>
            </div>

            <div className="stat-box">
              <h2>2500</h2>
              <p>Villages</p>
            </div>

            <div className="stat-box">
              <h2>1.6 Mn</h2>
              <p>Lives Impacted</p>
            </div>
          </div>
        </div>

        {/* CONTENT SECTION */}
        <div className="sst-content">
          <motion.div
            className="sst-text"
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.3 }}
          >
            <p>
              <span className="highlight-text">
                Srinivasan Services Trust (SST)
              </span>{" "}
              is the social arm of{" "}
              <span className="highlight-text">
                TVS Motor Company and Sundaram Clayton Limited
              </span>
              , working with the vision to partner in the transformation of
              rural India by enabling people and communities to achieve
              sustainable development. Through its presence in{" "}
              <span className="highlight-text">
                over 2500 villages
              </span>{" "}
              across{" "}
              <span className="highlight-text">
                five states—Tamil Nadu, Karnataka, Maharashtra, Andhra
                Pradesh, and Himachal Pradesh
              </span>
              —SST focuses on enabling sustainable solutions in areas such as{" "}
              <span className="highlight-text">
                economic development, education, health, environment,
                infrastructure, and cultural upliftment.
              </span>
            </p>

            <p>&nbsp;</p>

            <p>
              By closely engaging with communities and government bodies, SST
              fosters long-term change through{" "}
              <span className="highlight-text">
                awareness-building, skills training, and empowerment programs.
              </span>{" "}
              Its approach emphasizes internal transformation—encouraging
              communities to take ownership of progress and sustain it from
              within. Through this continuous journey of development, SST
              continues to positively impact{" "}
              <span className="highlight-text">
                millions of lives.
              </span>
            </p>

            <p>&nbsp;</p>

            <p>
              Know more at:{" "}
              <a
                href="https://www.tvssst.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="highlight-text">
                  https://www.tvssst.org/
                </span>
              </a>
            </p>
          </motion.div>
        </div>
      </motion.div>

      <Footer />
    </section>
  );
}